import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { categoryLabels } from "@/mocks/articles";

interface Props {
  articles: Article[];
}

export default function HotRanking({ articles }: Props) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-background-200 bg-background-100">
        <h3 className="font-heading text-[15px] font-bold text-foreground-900 flex items-center gap-2">
          <i className="ri-fire-line text-accent-500" />
          热门黑料榜
        </h3>
        <Link to="/black" className="text-[12px] text-foreground-500 hover:text-accent-600 cursor-pointer">
          全部
        </Link>
      </div>
      <ol className="divide-y divide-background-200">
        {articles.map((article, index) => (
          <li key={article.id}>
            <Link
              to={`/detail/${article.id}`}
              className="group flex items-start gap-3 px-4 py-3 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span
                className={`w-5 h-5 shrink-0 rounded text-[11px] font-bold flex items-center justify-center mt-0.5 ${
                  index < 3 ? "bg-accent-500 text-primary-950" : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              <span className="min-w-0">
                <span className="block text-[13.5px] font-medium text-foreground-800 leading-6 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </span>
                <span className="flex items-center gap-2 mt-1 text-[11.5px] text-foreground-400">
                  <span>{categoryLabels[article.category]}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {(article.views / 10000).toFixed(1)} 万
                  </span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}